import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const PersonalDetailsStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      [theme.breakpoints.down("md")]: {
        marginBottom: "16px",
      },
      padding: "0",
      height: "fit-content",
      wordBreak: "break-word",
    },

    label: {
      fontFamily: "Roobert, sans-serif",
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "20px",
      color: "#002035",
    },

    content: {
      fontFamily: "Roobert, sans-serif",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "20px",
      color: "#5C6469",
    },
  }),
);
